import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Returns a click handler that resolves nav hrefs like:
 *   - "/#about"        → go to home, scroll to #about
 *   - "#about"         → smooth-scroll to #about on current page
 *   - "/media"         → route to /media (scrolls to top)
 *   - "/"              → route to home top
 */
export function useNavHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (href) => (e) => {
      if (e && typeof e.preventDefault === "function") e.preventDefault();
      if (!href) return;

      // Same-page hash link
      if (href.startsWith("#")) {
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      // Route + hash ("/#about")
      if (href.startsWith("/#")) {
        const hash = href.slice(1);
        if (location.pathname === "/") {
          const el = document.querySelector(hash);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          navigate("/" + hash);
        }
        return;
      }

      // Full path route
      navigate(href);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    [navigate, location.pathname]
  );
}
